<template>
  <TopBar title="Which course are you interested in?" :step="step"/>
  <div class="step">
    <div class="multiselect-container">
      <Multiselect
          :value="course"
          @change="setFormData"
          :options="courses"
          :searchable="true"
          valueProp="title"
          trackBy="title"
          autocomplete="title"
          label="title"
          placeholder="Please select the program you wish to study"
          ref="multiselect"
      />
    </div>
    <button class="btn-check" :class="{ selected: tickSelected }" @click="notSure">
      <div class="circle">
        <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4.2L3.66667 7L9 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <div>I'm not sure which course I want to study.</div>
    </button>
  </div>
  <BottomBar :step="step" :valid="valid"/>
</template>
<script>
import { mapState } from 'vuex'

import TopBar from '@/components/TopBar'
import BottomBar from '@/components/BottomBar'
import Multiselect from '@vueform/multiselect'

export default {
  props: {
    step: {
      required: true
    }
  },
  components: {
    TopBar,
    BottomBar,
    Multiselect
  },
  computed: mapState({
    course: state => state.formData.course,
    courses: state => {
      if (state.formData.fieldOfStudy !== false) {
        let courses = state.courses.filter(course => course.disciplines.some(discipline => state.formData.fieldOfStudy === discipline.slug))
        courses = courses.filter(course => course.title.includes('Bachelor'))
        return courses
      }
      return state.courses
    },
    valid: state => state.formData.course !== null
  }),
  data () {
    return {
      tickSelected: false
    }
  },
  methods: {
    setFormData (value) {
      this.$store.commit('setFormData', { key: 'course', value })
      this.$router.push('/step/3')
    },
    notSure () {
      this.tickSelected = !this.tickSelected
      document.location.href = '/online-courses'
    }
  },
  mounted () {
    this.$refs.multiselect.$el.focus()
  }
}
</script>
<style lang="scss">
@import './../assets/scss/mixins';

.step-2 {
  .step {
    max-width: 50.5rem;
    margin: 0 auto;
    position: relative;

    @include respond-below(lg) {
      padding-bottom: 6rem;
    }
  }

  .multiselect-container {
    min-height: 22rem;
    margin-bottom: 1rem;
  }

  .multiselect-dropdown {
    height: 17.5rem;
    max-height: 17.5rem;
  }

  @include respond-below(lg) {
    .btn-check {
      position: absolute;
      top: 100px;
      left: 0;
    }
  }
}
</style>
